// extracted by mini-css-extract-plugin
module.exports = {"box":"box_box__2HA1l"};